import DialogRechercheParticipant from './DialogRechercheParticipant';

export default {
  install(Vue) {
    Vue.component('dialogRechercheParticipant', DialogRechercheParticipant);
  },
};
